export const reduxKey = '@@POPOVERS';
export const actionPrefix = '@@POPOVERS';

//# sourceMappingURL=constants.js.map